import { defineAction } from "rd-action-creators";

export const downloadStaticReportFileAction = defineAction<{ campaignId: string }>("DOWNLOAD_FILE_STARTED_ACTION");
export const downloadFileFinishedAction = defineAction("DOWNLOAD_FILE_FINISHED_ACTION");
export const downloadFileStateError = defineAction("DOWNLOAD_FILE_STATE_ERROR");
